<template>
	<div class="row">
		<div class="col-12">
			<div class="row" v-if="!isSimple">
				<div class="col-12">
					<date-picker
							v-model="date"
							range
							:lang="lang"
							:not-after="new Date()"
							format="DD MMMM YYYY"
							confirm
							:range-separator="'-'"
							class="account__datepicker"
					></date-picker>
				</div>
			</div>
			<div class="row" v-if="!isSimple">
				<div class="col-12 d-flex">
					<div class="btn btn-link btn-sm" @click="filtering = 'all'" :class="{ 'active': filtering === 'all'}">
                  <t tag="user.page.table.sportbets.btn.all"/>
               </div>
					<div class="btn btn-link btn-sm" @click="filtering = 'progress'" :class="{ 'active': filtering === 'progress'}">
                  <t tag="user.page.table.sportbets.btn.progress"/>
               </div>
					<div class="btn btn-link btn-sm" @click="filtering = 'end'" :class="{ 'active': filtering === 'end'}">
                  <t tag="user.page.table.sportbets.btn.ended"/>
               </div>
				</div>
			</div>

			<div class="table-wrapper" v-if="pageCount">
            <component
                :is="compact ? 'SportSimpleTable' : 'SportFullTable'"
               v-bind="{
                   tickets: betsPage
               }"
                @openBet="openBet($event)"
                @cancelBet="cancelBet($event)"
            />
			</div>

			<div class="row">
				<div class="col-12">
					<paginate v-if="pageCount && !simple"
							  v-model="page"
							  :page-count="pageCount"
							  :page-range="3"
							  :margin-pages="2"
							  :prev-text="tPrev"
							  :next-text="tNext"
							  :page-link-class="'page-link'"
							  :container-class="'pagination mb-0 justify-content-center'"
							  :page-class="'page-item'"
							  :prev-link-class="'page-link'"
							  :prev-class="'page-item'"
							  :next-link-class="'page-link'"
							  :next-class="'page-item'"
					>
					</paginate>
				</div>
			</div>
			<!--<div class="row" v-if="!pageCount">
				<div class="col-12">
					<div class="jumbotron">
						<h2 class="display-6">{{t('user.page.bets.no-bets')}}</h2>
					</div>
				</div>
			</div>-->
			<div class="row" v-if="pageCount > 1 && simple">
				<div class="col-12">
					<router-link :to="{name: 'UserBets'}" class="btn btn-secondary">{{t('user.page.bets.showmore')}}</router-link>
				</div>
			</div>
		</div>

		<bet-cancel-modal @update="update" :bet="toCancel" @close="toCancel = null"></bet-cancel-modal>

		<!--Bet details modal-->
		<SportModal
          v-if="detailsId !== null && detailedBet"
          @close="closeDetails"
          :ticket="detailedBet"
      />
   </div>
</template>
<script>
	import Vuex from 'vuex';
	import DatePicker from 'vue2-datepicker';
	import Paginate from 'vuejs-paginate';
	import BetCancelModal from '@/components/user/UserBetCancel';
	import moment from 'moment-timezone';
   import SportSimpleTable from "@/components/user/modules/sport/SportSimpleTable";
   import SportFullTable from "@/components/user/modules/sport/SportFullTable";

	//TODO: in Datepicker v.3 that should be fixed by plugin author
	DatePicker.fecha.i18n.monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];


	export default {
		name: 'sport-bets-table',
		components: {
			DatePicker,
			Paginate,
			BetCancelModal,
         SportSimpleTable,
         SportFullTable,
         SportModal: ()=> import("@/components/user/modules/sport/SportModal")
		},
		props: {
         simple:{
            type: Boolean,
            default: false
         },
         compact: {
            type: Boolean,
            default: false
         }
      },
		data() {
			return {

				detailsId: null,
				toCancel: null,
				date: [
				],
				page: 1,
				pagelength: 10,
				tPrev: '«',
				tNext: '»',
				filtering: 'all', // all/progress/end

			}
		},
		computed:{
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
			isSimple(){

				return this.simple;
			},
			from:{
				get(){
					return this.$store.state.user.sport_bets.from;
				}
			},
			to:{
				get(){
					return this.$store.state.user.sport_bets.to;
				}
			},
			bets(){

				let filtered;

				if(this.filtering === 'all'){
					//show all bets
					filtered = this.$store.getters.getSportBets;
				}else{
					//Filter by parameters
					filtered = this.$store.getters.getSportBets.filter((ticket)=>{
						switch (this.filtering){

							case('progress'):
								return ticket.status === 'OPEN';

							case('end'):
								return ticket.status !== 'OPEN';
						}
					});
				}
				return filtered;
			},
			detailedBet(){
				return this.bets.find((bet)=> bet.ticket_id === this.detailsId );
			},
			betsPage(){
				let pp = this.page -1;




				//Slice to pages
				return this.bets.slice(pp*this.pagelength,  pp*this.pagelength + this.pagelength);
			},
			pageCount(){
				return Math.ceil(this.bets.length / this.pagelength );
			},
			pathBetId(){
				return this.$route.params.betId;
			}
		},
		watch: {
			date: {
				handler(val){

					if(typeof val === 'object' && val.length === 2){


						this.$store.commit('setUserSportBetsFromTo', {
							from: val[0],
							to: val[1],
							limit: ''
						});

					}

				},
				deep: true
			},
			bets(){
				this.page = 1;
			},
			simple(){
				this.checkSimple();
			}
		},
		mounted(){
			if(this.from !== '' && this.to !== ''){
				this.date = [
					moment(this.from).toDate(),
					moment(this.to).toDate()
				];
			}

			if(this.$route.name === 'UserSportBetsWithId' && this.pathBetId){
				//this.detailsId = parseInt(this.pathBetId);  //disabled by PMCLNL-371
			}
			this.checkSimple();

		},
		methods:{


			checkSimple(){
				//Check if we show preview with list limit 10, or we should show full list
				let params = {
					from: '',
					to: '',
					limit: ''
				};
				if(!this.simple || (this.from !== '' && this.to !== '')){
					this.pagelength = 15;
					params.from = this.from || '';
					params.to = this.to || '';
				}else{
					//Simply show 10 last bets
					params.limit = 5;
				}

				this.$store.commit('setUserSportBetsFromTo', params);
			},
			update(){
				this.$store.dispatch('getUserSportBets');

			},



         openBet(id){
            this.detailsId = id;
         },
			cancelBet(bet){
				this.toCancel = bet;
			},




			closeDetails(){
				this.detailsId = null;
			}
		}
	}
</script>
<style lang="scss">

	.btn-open-details{
		&:hover{
			color: #0b7e91;
		}
	}
</style>
